import React, { Component } from 'react'

import close from './../css/b_06.svg'

export default class Lightbox extends Component {
  close() {
    this.props.setSelectedPhotoIndex(-1)
  }

  // not used
  lastPhoto(e) {
    e.stopPropagation()
    if (this.props.selectedPhotoIndex === 0) {
      this.props.setSelectedPhotoIndex(this.props.photos.length - 1)
    } else {
      this.props.setSelectedPhotoIndex(this.props.selectedPhotoIndex - 1)
    }
  }

  nextPhoto(e) {
    e.stopPropagation()
    if (this.props.selectedPhotoIndex === this.props.photos.length - 1) {
      this.props.setSelectedPhotoIndex(0)
    } else {
      this.props.setSelectedPhotoIndex(this.props.selectedPhotoIndex + 1)
    }
  }

  stop(e) {
    e.stopPropagation()
  }

  render() {
    if (this.props.selectedPhotoIndex === -1) {
      return null
    }
    let photo = this.props.photos[this.props.selectedPhotoIndex]
    return (
      <div onClick={this.close.bind(this)} className="lightbox">
        <div className={'lightbox-flex'}>
          <img
            id={'lightbox-flex-photo'}
            src={photo.link}
            alt={photo.alt}
            onClick={this.nextPhoto.bind(this)}
          />
          <img
            className="lightbox-flex-close"
            src={close}
            alt="Schliessen"
            onClick={this.close.bind(this)}
          />
          <div
            onClick={this.stop.bind(this)}
            className="lightbox-flex-copyright"
          >
            {photo.copyright}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/lightbox.js